import { render } from "./GuahaoPage.vue?vue&type=template&id=a501b812&scoped=true"
import script from "./GuahaoPage.vue?vue&type=script&lang=js"
export * from "./GuahaoPage.vue?vue&type=script&lang=js"

import "./GuahaoPage.vue?vue&type=style&index=0&id=a501b812&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a501b812"]])

export default __exports__